import { render, staticRenderFns } from "./cms-block-footer.vue?vue&type=template&id=533f634a&scoped=true"
import script from "./cms-block-footer.vue?vue&type=script&lang=js"
export * from "./cms-block-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533f634a",
  null
  
)

export default component.exports